/**
 * Candidate Status Constants
 * Defines all possible candidate statuses across the hiring pipeline
 */

export const CANDIDATE_STATUSES = [
  {
    key: 'applied',
    label: 'Applied',
    color: '#1E40AF', 
    bg: '#EFF6FF',
    border: '#BFDBFE',
    description: 'Initial application received'
  },
  {
    key: 'screen_pending',
    label: 'Screen Pending',
    color: '#64748B',
    bg: '#F1F5F9',
    border: '#CBD5E1',
    description: 'Screening in progress'
  },
  {
    key: 'screen_selected',
    label: 'Screen Selected',
    color: '#059669',
    bg: '#ECFDF5',
    border: '#6EE7B7',
    description: 'Selected after screening round'
  },
  {
    key: 'screen_rejected',
    label: 'Screen Rejected',
    color: '#DC2626',
    bg: '#FEE2E2',
    border: '#FECACA',
    description: 'Rejected in screening round'
  },
  {
    key: 'l1_scheduled',
    label: 'L1 Scheduled',
    color: '#EA580C',
    bg: '#FEF3C7',
    border: '#FCD34D',
    description: 'Level 1 interview scheduled'
  },
  {
    key: 'l1_select',
    label: 'L1 Select',
    color: '#059669',
    bg: '#ECFDF5',
    border: '#6EE7B7',
    description: 'Selected in Level 1 interview'
  },
  {
    key: 'l1_reject',
    label: 'L1 Reject',
    color: '#DC2626',
    bg: '#FEE2E2',
    border: '#FECACA',
    description: 'Rejected in Level 1 interview'
  },
  {
    key: 'l2_scheduled',
    label: 'L2 Scheduled',
    color: '#EA580C',
    bg: '#FEF3C7',
    border: '#FCD34D',
    description: 'Level 2 interview scheduled'
  },
  {
    key: 'l2_select',
    label: 'L2 Select',
    color: '#059669',
    bg: '#ECFDF5',
    border: '#6EE7B7',
    description: 'Selected in Level 2 interview'
  },
  {
    key: 'l2_reject',
    label: 'L2 Reject',
    color: '#DC2626',
    bg: '#FEE2E2',
    border: '#FECACA',
    description: 'Rejected in Level 2 interview'
  },
  {
    key: 'shared_to_client',
    label: 'Shared to Client',
    color: '#7C3AED',
    bg: '#F3E8FF',
    border: '#D8B4FE',
    description: 'Profile shared with client'
  },
  {
    key: 'hr_round',
    label: 'HR Round',
    color: '#0891B2',
    bg: '#ECFDF5',
    border: '#06B6D4',
    description: 'HR round scheduled'
  },
  {
    key: 'col_issued',
    label: 'COL Issued',
    color: '#7C3AED',
    bg: '#F3E8FF',
    border: '#D8B4FE',
    description: 'Conditional Offer Letter issued'
  },
  {
    key: 'col_accepted',
    label: 'COL Accepted',
    color: '#059669',
    bg: '#ECFDF5',
    border: '#6EE7B7',
    description: 'Conditional offer accepted'
  },
  {
    key: 'col_rejected',
    label: 'COL Rejected',
    color: '#DC2626',
    bg: '#FEE2E2',
    border: '#FECACA',
    description: 'Conditional offer rejected'
  },
  {
    key: 'fol_issued',
    label: 'FOL Issued',
    color: '#EA580C',
    bg: '#FEF3C7',
    border: '#FCD34D',
    description: 'Final Offer Letter issued'
  },
  {
    key: 'fol_accepted',
    label: 'FOL Accepted',
    color: '#059669',
    bg: '#ECFDF5',
    border: '#6EE7B7',
    description: 'Final offer accepted'
  },
  {
    key: 'fol_rejected',
    label: 'FOL Rejected',
    color: '#DC2626',
    bg: '#FEE2E2',
    border: '#FECACA',
    description: 'Final offer rejected'
  },
  {
    key: 'joined',
    label: 'Joined',
    color: '#065F46',
    bg: '#D1FAE5',
    border: '#6EE7B7',
    description: 'Candidate has joined the company'
  },
  {
    key: 'candidate_backed',
    label: 'Candidate Backed',
    color: '#92400E',
    bg: '#FEF3C7',
    border: '#FCD34D',
    description: 'Candidate backed out'
  },
  {
    key: 'another_profile_requested',
    label: 'Another Profile Requested',
    color: '#9A3412',
    bg: '#FFF7ED',
    border: '#FDBA74',
    description: 'Hiring manager requested another profile'
  },
  {
    key: 'cancelled',
    label: 'Cancelled',
    color: '#991B1B',
    bg: '#FEE2E2',
    border: '#FCA5A5',
    description: 'Interview cancelled'
  },
  {
    key: 'drop',
    label: 'Drop',
    color: '#991B1B',
    bg: '#FEE2E2',
    border: '#FECACA',
    description: 'Candidate dropped'
  },
  {
    key: 'hold',
    label: 'Hold',
    color: '#92400E',
    bg: '#FEF3C7',
    border: '#FCD34D',
    description: 'Application on hold'
  }
];

export const normalizeStatus = (status) => {
  if (!status) return status;
  return status.replace(/^screening_/, "screen_");
};

export const getStatusStyle = (statusKey) => {
  const status = CANDIDATE_STATUSES.find(s => s.key === normalizeStatus(statusKey));
  return status ? {
    color: status.color,
    backgroundColor: status.bg,
    border: `1px solid ${status.border}`
  } : {};
};

export const getStatusLabel = (statusKey) => {
  const status = CANDIDATE_STATUSES.find(s => s.key === normalizeStatus(statusKey));
  return status?.label || statusKey;
};
